export const isUsaPerson = (stepData) => stepData.businessUnderUsaTaxLaw === true || stepData.signatoryUnderUsaTaxLaw === true;
